import dayjs from 'dayjs';
import { isStringOrNumber, isEmpty, isArray, isObject, clone } from '../_utils/lang';
import { DATA_TYPE } from './constants';
import regions from './regions';
const treeLoop = (children) => {
    children.map((el, index) => {
        el.index = index;
        el.value = isEmpty(el.value) ? el.text : el.value;
        if (el.children) {
            treeLoop(el.children);
        }
    });
    return children;
};
export const getDataType = (data) => {
    if (data === DATA_TYPE.REGION) {
        return DATA_TYPE.REGION;
    }
    else if (data === DATA_TYPE.DATE) {
        return DATA_TYPE.DATE;
    }
    else if (data === DATA_TYPE.DATE_RANGE) {
        return DATA_TYPE.DATE_RANGE;
    }
    else if (data === DATA_TYPE.TIME) {
        return DATA_TYPE.TIME;
    }
    else if (isArray(data[0])) {
        return DATA_TYPE.MULTI;
    }
    else if (isObject(data[0])) {
        if (data.find((el) => el.children)) {
            return DATA_TYPE.TREE;
        }
        else {
            return DATA_TYPE.SINGLE;
        }
    }
    else {
        return DATA_TYPE.SINGLE;
    }
};
export const convertTextToRecord = (text, unit) => {
    return {
        text: `${text < 10 ? '0' + text : text}${unit || ''}`,
        value: text
    };
};
export const getTimes = (step) => {
    const hours = [];
    const mins = [];
    for (let index = 0; index < 24; index += step.hour) {
        hours.push(convertTextToRecord(index));
    }
    for (let index = 0; index < 60; index += step.minute) {
        mins.push(convertTextToRecord(index));
    }
    return [hours, mins];
};
export const getFixedData = (data, step) => {
    const type = getDataType(data);
    if (type === DATA_TYPE.REGION) {
        const regionData = clone(regions);
        return treeLoop(regionData);
    }
    else if (type === DATA_TYPE.MULTI) {
        const multiData = data;
        return multiData.map((el) => {
            return el.map((cl, index) => {
                if (isStringOrNumber(cl)) {
                    return {
                        index,
                        text: cl,
                        value: cl
                    };
                }
                else if (isObject(cl)) {
                    const dl = cl;
                    return Object.assign(Object.assign({ index }, dl), { value: isEmpty(dl.value) ? dl.text : dl.value });
                }
            });
        });
    }
    else if (type === DATA_TYPE.TREE) {
        const treeData = clone(data);
        return treeLoop(treeData);
    }
    else if (type === DATA_TYPE.DATE || type === DATA_TYPE.DATE_RANGE) {
        return data;
    }
    else if (type === DATA_TYPE.TIME) {
        return getTimes(step);
    }
    else {
        const singleData = data;
        return singleData.map((el, index) => {
            if (isStringOrNumber(el)) {
                return {
                    index,
                    text: el,
                    value: el
                };
            }
            else if (isObject(el)) {
                const cl = el;
                return Object.assign(Object.assign({ index }, cl), { value: isEmpty(cl.value) ? cl.text : cl.value });
            }
        });
    }
};
export const completeDate = (date) => {
    const dateArr = date.split(/-|\//).map((el) => parseInt(el));
    let year;
    let month;
    let day;
    const nowYear = new Date().getFullYear();
    if (dateArr[0] > 12) {
        year = dateArr[0] || nowYear;
        month = dateArr[1] > 12 ? 1 : dateArr[1] || 1;
        day = dateArr[2] > 31 ? 1 : dateArr[2] || 1;
    }
    else {
        year = nowYear;
        month = dateArr[0] || 1;
        day = dateArr[2] > 31 ? 1 : dateArr[1] || 1;
    }
    return `${year}-${month}-${day}`;
};
export const convertDate = (date) => {
    let rightDate = date;
    if (typeof date === 'string') {
        rightDate = completeDate(date);
    }
    else if (new Date(date).toLocaleString() === 'Invalid Date') {
        rightDate = new Date();
    }
    return new Date(dayjs(rightDate).toISOString());
};
export const getYears = ({ range, step = 1 }) => {
    const years = [];
    const start = (range && range[0] && convertDate(range[0]).getFullYear()) || 1900;
    const end = (range && range[1] && convertDate(range[1]).getFullYear()) || 2099;
    for (let index = start; index <= end; index += step) {
        years.push(convertTextToRecord(index, '年'));
    }
    return years;
};
export const getMonths = ({ year, range, step = 1 }) => {
    const months = [];
    let minYear;
    let minMonth;
    let maxYear;
    let maxMonth;
    if (range) {
        if (range[0]) {
            minYear = convertDate(range[0]).getFullYear();
            minMonth = convertDate(range[0]).getMonth() + 1;
        }
        if (range[1]) {
            maxYear = convertDate(range[1]).getFullYear();
            maxMonth = convertDate(range[1]).getMonth() + 1;
        }
    }
    for (let index = 1; index <= 12; index += step) {
        if (((year && minYear && minYear === year) || !year || !minYear) && minMonth && index < minMonth) {
            continue;
        }
        else if (((year && maxYear && maxYear === year) || !year || !maxYear) && maxMonth && index > maxMonth) {
            continue;
        }
        months.push(convertTextToRecord(index, '月'));
    }
    return months;
};
export const getDays = ({ year, month, range, step = 1 }) => {
    const now = new Date();
    year = year || now.getFullYear();
    month = month || now.getMonth() + 1;
    const days = [];
    for (let index = 1; index <= 31; index += step) {
        const day = new Date(`${year}/${month}/${index} 00:00:00`);
        if (day.toLocaleString() !== 'Invalid Date' && day.getMonth() + 1 === month) {
            let minYear;
            let minMonth;
            let minDay;
            let maxYear;
            let maxMonth;
            let maxDay;
            if (range) {
                if (range[0]) {
                    minYear = convertDate(range[0]).getFullYear();
                    minMonth = convertDate(range[0]).getMonth() + 1;
                    minDay = convertDate(range[0]).getDate();
                }
                if (range[1]) {
                    maxYear = convertDate(range[1]).getFullYear();
                    maxMonth = convertDate(range[1]).getMonth() + 1;
                    maxDay = convertDate(range[1]).getDate();
                }
            }
            if (((year && minYear && minYear === year) || !year || !minYear) &&
                minMonth &&
                minMonth === month &&
                minDay &&
                index < minDay) {
                continue;
            }
            else if (((year && maxYear && maxYear === year) || !year || !maxYear) &&
                maxMonth &&
                maxMonth === month &&
                maxDay &&
                index > maxDay) {
                continue;
            }
            days.push(convertTextToRecord(index, '日'));
        }
    }
    /** 如果没有年选项，则2月份为29天 */
    if (!year && month === 2) {
        const lastDay = days[days.length - 1].value + step;
        if (lastDay <= 29) {
            days.push(convertTextToRecord(lastDay, '日'));
        }
    }
    return days;
};
export const initDateYear = (date) => {
    return new Date(date.setFullYear(new Date().getFullYear()));
};
export const deleteDateUnit = (text) => {
    return text.replace(/年|月|日/g, '');
};
